import { render, staticRenderFns } from "./ModelList.vue?vue&type=template&id=2b20a52a&scoped=true&"
import script from "./ModelList.vue?vue&type=script&lang=js&"
export * from "./ModelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b20a52a",
  null
  
)

export default component.exports